export default {
    API_ENDPOINT: 'https://aqueous-bayou-54903.herokuapp.com/api',
    TOKEN_KEY: 'costless-creatives-client-auth-token',
  }
  